import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';

export const deleteEntidad = async (
  id: UUID,
): Promise<Result<boolean, APIValidationError>> => {
  return validatedApiCall<boolean>(`/api/entidades/${id}`, {
    method: 'DELETE',
    auth: true,
  });
};
